/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { ExpandableProvider } from '@finbeat/react-toolkit';
import { TariffGroup, TariffGroupCreditProduct } from 'models/api/tariffGroup';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { Col, Label, Row } from 'reactstrap';
import TariffGroupCreditProductAddButton from './TariffGroupCreditProductAddButton';
import {
    TariffGroupCreditProductFormWrapper,
    TariffGroupCreditProductValidatedForm,
} from './TariffGroupCreditProductValidatedForm';

type TariffGroupCreditProductsListProps = {
    id: number;
    disabled: boolean;
};

const TariffGroupCreditProductsList = ({ id, disabled }: TariffGroupCreditProductsListProps) => {
    const { control, watch, setValue } = useFormContext<TariffGroup>();
    const { prepend } = useFieldArray({
        control,
        name: `tariffGroupCreditProducts`,
    });

    const handleTariffGroupCreditProductAdd = (newRecord: TariffGroupCreditProduct) => {
        prepend(newRecord);
    };

    const handleTariffGroupCreditProductDelete = (idx: number) => {
        setValue(`tariffGroupCreditProducts.${idx}.isDeleted`, true);
    };

    const tariffGroupCreditProducts = watch('tariffGroupCreditProducts');

    return (
        <>
            <Row>
                <Col>
                    <Label className="align-middle mb-4">
                        <Trans i18nKey={'BackOfficeTariffs'} />
                    </Label>
                    <TariffGroupCreditProductAddButton
                        tariffGroupId={id}
                        handleTariffGroupCreditProductAdd={handleTariffGroupCreditProductAdd}
                        disabled={disabled}
                    />
                </Col>
            </Row>
            <ExpandableProvider>
                {tariffGroupCreditProducts.map(
                    (cp, idx) =>
                        cp &&
                        !cp.isDeleted && (
                            <TariffGroupCreditProductFormWrapper
                                id={cp.creditProduct?.id}
                                name={cp.creditProduct?.name}
                                key={cp.id}
                                onDelete={() => handleTariffGroupCreditProductDelete(idx)}
                                disabled={disabled}
                            >
                                <TariffGroupCreditProductValidatedForm
                                    idx={idx}
                                    disabled={disabled}
                                    showBaseCheckbox={
                                        tariffGroupCreditProducts.filter((p) => !p.isDeleted)
                                            .length > 1
                                    }
                                    {...cp}
                                />
                            </TariffGroupCreditProductFormWrapper>
                        )
                )}
            </ExpandableProvider>
        </>
    );
};

export default TariffGroupCreditProductsList;
